function mhProducts(){
    $('.product').each(function () {
        var $product = $(this);

        if ($product.find('span.product-appendix').length) {
            $product.find('a.name').append($product.find('span.product-appendix'));
        }

        var $prices = $product.find('.prices');
        var $flag = $product.find('.flag-discount');

        if (!$flag.length) return;

        // Smaže pouze text "od", ale nechá "až" i .price-save ve flagu
        $flag.contents().each(function () {
            if (this.nodeType === 3) {
                this.nodeValue = this.nodeValue
                    .replace(translation('od'), '')
                    .replace(/\s+/g, ' ');
            }
        });

        $product.find('.price-final small').remove();

        if (
            !$prices.find('.price-save').length &&
            !$prices.closest('.products').is($productsBlock)
        ) {
            $prices.prepend($flag.find('.price-standard').clone());
            $prices.append($flag.find('.price-save').clone());
        }

        var $priceSaveInPrices = $prices.find('.price-save').last();

        if ($priceSaveInPrices.length && $priceSaveInPrices.find('small').length === 0) {
            $priceSaveInPrices.prepend('<small>' + translation('az') + '</small>');
        }
    });
}

$(document).ready(function() {
    mhProducts()
  })
document.addEventListener('ShoptetDOMContentLoaded', function() {
    mhProducts()
});

document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    mhProducts()
});

document.addEventListener('ShoptetPageSortingChanged', function() {
    mhProducts();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    mhProducts();
});